module.exports = __webpack_public_path__ + "static/media/page-arrow-left-first.d0125a50.svg";